import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { billingApi } from './api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Sparkles, X } from 'lucide-react';
import { toast } from 'sonner';

const SAVINGS_LABEL = {
  apex_ai_monthly: 'Save ~17% vs monthly',
  coach_1to1_monthly: 'Save ~17% vs monthly',
};

export default function AnnualUpgradeBanner({ sub }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!sub || dismissed) return null;
  if (sub.interval !== 'month') return null;
  if (!sub.annual_upgrade_plan_key) return null;
  // Don't show during a cancellation
  if (sub.cancel_at_period_end) return null;

  const upgrade = async () => {
    setBusy(true);
    try {
      const { url } = await billingApi.checkout(sub.annual_upgrade_plan_key);
      if (url) {
        window.location.href = url;
      } else {
        toast.error('Could not start upgrade.');
      }
    } catch (e) {
      toast.error(e.message || 'Could not start upgrade.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="border-2 border-[#4FBCC7]/40 bg-gradient-to-r from-[#E6F4F6] via-white to-[#F0F4F4]" data-testid="annual-upgrade-banner">
      <CardContent className="p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <div className="w-10 h-10 rounded-lg bg-[#004C54] text-white flex items-center justify-center shrink-0">
              <Sparkles className="h-4 w-4" />
            </div>
            <div className="min-w-0">
              <div className="font-heading text-[15px] font-bold leading-tight">Switch to annual and save</div>
              <div className="text-[13px] text-foreground/65 mt-0.5">
                {SAVINGS_LABEL[sub.active_plan_key] || 'Get a discount when you switch to yearly billing.'} Apply at checkout.
              </div>
            </div>
          </div>
          <div className="flex gap-2 sm:gap-1.5 shrink-0">
            <Button onClick={upgrade} disabled={busy} className="bg-[#004C54] hover:bg-[#003a40] text-white font-semibold" data-testid="annual-upgrade-cta">
              {busy ? 'Opening…' : 'Switch to annual'}
            </Button>
            <button
              type="button"
              onClick={() => setDismissed(true)}
              className="px-2 text-foreground/50 hover:text-foreground/80"
              aria-label="Dismiss"
              data-testid="annual-upgrade-dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
